<template>
  <div class="home">
    <div class="content">
      <div class="activity_time activity_end" v-if="isActivityEnd"></div>
      <div class="activity_time" v-else>
        <div class="title">倒计时</div>
        <div class="time">{{ countDown.day }}</div>
        天
        <div class="time">{{ countDown.hour }}</div>
        时
        <div class="time">{{ countDown.minute }}</div>
        分
      </div>

      <img :src="pageConfig.headerImg" alt="" />
      <img v-for="(item, index) in pageConfig.otherImg" :key="index" alt="" v-lazy="item" />
    </div>
    <customer-service />
    <!--    <sharePosterNew></sharePosterNew>-->

    <div class="home_footer">
      <div class="receive" @click="toReceive">我是教师 马上申领</div>
    </div>
  </div>
</template>

<script>
import customerService from '../components/customerService'
import { isApp, getNowTime } from '../../common/utils/xesFunction.js'
// import sharePosterNew from '../components/sharePosterNew'
export default {
  name: 'workwxHome',
  components: {
    customerService
    // sharePosterNew
  },
  data() {
    return {
      pageuid: 'activitiesPage1',
      isApp: false, // 是否为app
      isLogin: false, // 是否有登录态
      isActivityEnd: false, // 活动是否结束
      applyEndTime: '', // 活动结束时间
      countDown: {
        day: '0',
        hour: '0',
        minute: '0',
        second: '0'
      },
      pageConfig: {
        headerImg: '',
        otherImg: null
      },
      wxQrcode: '',
      activityEndMsg: '活动已经结束, 请关注下次活动'
    }
  },
  created() {
    this.isApp = isApp()
    this.init()
    this.$xesLogger.loadMsg({
      pageuid: this.pageuid
    })
  },
  methods: {
    // 页面初始化
    async init() {
      const time = await getNowTime()
      const localTime = +new Date()
      this.countDown.nowTime = (Math.abs(+time - localTime) < 10 * 1000
        ? new Date()
        : time
      ).getTime()
      this.countDown.localTime = localTime
      this.activityPage('init')
    },
    // 活动介绍页活动状态接口
    async activityPage(params) {
      const res = await this.$api.activityPage({ isShow: 0 })
      if (res.code === 0 && res.stat === 1) {
        const { data } = res
        localStorage.setItem('wxQrcode', data.wxQrcode)
        this.activityApplyType = Number(data.activityApplyType)
        if (params === 'init') {
          this.isActivityEnd = !Number(data.activityStatus)
          this.applyEndTime = data.applyEndTime
          Object.assign(this.pageConfig, {
            headerImg: data.headerImage[0],
            otherImg: data.otherImage
          })
          this.wxQrcode = data.wxQrcode
          this.activityCountDown()
        } else {
          this.jumpTpReceive(data.applyStatus)
        }
      }
    },
    // 活动结束倒计时
    async activityCountDown() {
      //   this.isActivityEnd = true
      const applyEndTime = this.applyEndTime.replace(/-/g, '/')
      const endTime = new Date(applyEndTime)
      const time = this.countDown.nowTime + (new Date().getTime() - this.countDown.localTime)
      const timeDiff = Math.round((endTime.getTime() - time) / 1000)
      const day = parseInt(timeDiff / 3600 / 24)
      const hour = parseInt((timeDiff / 3600) % 24)
      const minute = parseInt((timeDiff / 60) % 60)
      const second = parseInt(timeDiff % 60)
      // 获取还剩多少天
      this.countDown.day = day
      // 获取还剩多少小时
      this.countDown.hour = hour.toString().padStart(2, 0)
      // 获取还剩多少分钟
      this.countDown.minute = minute.toString().padStart(2, 0)
      // 获取还剩多少秒
      this.countDown.second = second.toString().padStart(2, 0)
      if (day <= 0 && hour <= 0 && minute <= 0 && second <= 0) {
        this.isActivityEnd = true
        return
      }
      setTimeout(this.activityCountDown, 1000)
    },
    // 点击去申领
    toReceive() {
      this.$xesLogger.clickMsg({
        params: {
          pageuid: this.pageuid,
          clickid: 1,
          action: 'click_get_pv',
          clickname: '点击领取'
        }
      })
      if (this.isActivityEnd) {
        // this.$refs.activityEndPopup.show = true
        this.$xesAlert({
          title: '提示',
          message: this.activityEndMsg
        })
      } else {
        console.log('活动未结束...')
        this.$router.push({
          name: 'workwxHint',
          query: {
            wxQrcode: window.btoa(this.wxQrcode)
          }
        })
      }
    },
    // 分享海报
    sharePoster() {
      this.$xesLogger.clickMsg({
        params: {
          pageuid: this.pageuid,
          clickid: 2,
          action: 'click_share1_pv',
          clickname: '点击转发好友button'
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.home {
  width: 100%;
  min-height: 100vh;

  .tal_login_tip {
    margin-top: 4px;
    margin-bottom: 12px;
    font-size: 28/2px;
    font-weight: 500;
    font-family: PingFang SC Medium, PingFang SC Medium-Medium;
    line-height: 45/2px;
    text-align: left;
    color: #5b6169;
    letter-spacing: -1px;
  }

  .content {
    position: relative;

    .activity_end {
      width: 172/2px;
      height: 46/2px;
      background-image: url('../assets/images/end_home.png');
      background-size: cover;
    }

    .activity_time {
      position: absolute;
      top: 1190/2px;
      left: 35/2px;
      display: flex;
      font-size: 25/2px;
      font-weight: 600;
      line-height: 46/2px;
      text-align: center;
      color: #ffeec4;

      .title {
        width: 114/2px;
        height: 46/2px;
        color: #9a5c24;
        background-image: url('../assets/images/countDown1_home.png');
        background-size: cover;
      }

      .time {
        width: 46/2px;
        height: 46/2px;
        margin: 0 2px;
        color: #9a5c24;
        background-image: url('../assets/images/countDown2_home.png');
        background-size: cover;
      }
    }
  }

  .home_footer {
    position: fixed;
    bottom: 0;
    left: 0;
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding: 28/2px 40/2px;
    font-size: 38/2px;
    font-weight: 500;
    font-family: FZLTZHJW -GB1-0, FZLTZHJW -GB1-0--GB1-0;
    line-height: 90/2px;
    text-align: center;
    background: white;

    .receive {
      display: block;
      width: 426/2px;
      height: 90/2px;
      margin: 0 auto;
      color: #fff;
      background: #00aced;
      border-radius: 45px;
    }
  }
}
</style>
